<dl class="sheet-facts">
  @if (conservationData?.conservationStatus?.definition) {
    <div>
      <dt>Stato di conservazione</dt>
      <dd>{{ conservationData.conservationStatus.definition }}</dd>
    </div>
  }
  @if (conservationData?.specificIndications) {
    <div>
      <dt>Indicazioni specifiche</dt>
      <dd>{{ conservationData.specificIndications }}</dd>
    </div>
  }
</dl>
